// extracted by mini-css-extract-plugin
export default {"upsellContainer":"OtUNG_aj","upsellDesktop":"_13XjcBlW","upsellMobile":"_19vordBJ","upsellTitle":"eH3OpRY9","upsellButton":"sTSf0M7W"};